<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" style="display: flex; justify-content: space-between">
        <h3>Site and Parcel Exploration</h3>
        <div class="header-button-container">
            <div class="checkbox" style="margin: 0 5px 0 0">
                @if (refreshingSites) {
                    <span> <ws-ace-loader [inline]="true"></ws-ace-loader>&nbsp;Processing... </span>
                }
                @if (!refreshingSites && isTopLevel && companyHasSubsidiaries) {
                    <label>
                        <input
                            type="checkbox"
                            [(ngModel)]="includeSubsidiarySites"
                            (change)="includeSubsidiarySitesChanged()"
                        />Include Sites for Subsidiaries
                    </label>
                }
                @if (!refreshingSites) {
                    <label style="margin-left: 15px">
                        <input type="checkbox" [(ngModel)]="activeOnly" (change)="getStatesWithSites()" />Exclude
                        Inactive
                    </label>
                }
            </div>
        </div>
    </div>
    <div class="panel-flat-body">
        @if (serverAction) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        @if (!serverAction) {
            <div>
                @if (states?.length) {
                    <div>
                        <h4>{{ sitesTitle }}</h4>
                        <div class="row">
                            @for (state of states; track state) {
                                <button class="ace-btn btn-sm btn-secondary col-lg-1" (click)="doQuickSearch(state)">
                                    {{ state }}
                                </button>
                            }
                        </div>
                    </div>
                }
                <hr />
                @if (hasWritePermission && !isConsultantPerspective) {
                    <button class="ace-btn btn-primary" (click)="addSite()">Add Site</button>
                }
            </div>
        }
    </div>
</div>
